/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Purchase_BtnInputs */

const en_purchase_btn = /** @type {(inputs: Purchase_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Purchase`)
};

const ar_purchase_btn = /** @type {(inputs: Purchase_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شراء`)
};

const de_purchase_btn = /** @type {(inputs: Purchase_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kauf`)
};

const es_purchase_btn = /** @type {(inputs: Purchase_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprar`)
};

const fr_purchase_btn = /** @type {(inputs: Purchase_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aller acheter`)
};

const it_purchase_btn = /** @type {(inputs: Purchase_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acquista`)
};

const ja_purchase_btn = /** @type {(inputs: Purchase_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`購入`)
};

const ko_purchase_btn = /** @type {(inputs: Purchase_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구매`)
};

const pt_br_purchase_btn = /** @type {(inputs: Purchase_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compra`)
};

const ru_purchase_btn = /** @type {(inputs: Purchase_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Купить`)
};

const th_purchase_btn = /** @type {(inputs: Purchase_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ซื้อ`)
};

const tr_purchase_btn = /** @type {(inputs: Purchase_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satın al`)
};

const zh_cn_purchase_btn = /** @type {(inputs: Purchase_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前往购买`)
};

const zh_tw_purchase_btn = /** @type {(inputs: Purchase_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前往購買`)
};

/**
* | output |
* | --- |
* | "Purchase" |
*
* @param {Purchase_BtnInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const purchase_btn = /** @type {((inputs?: Purchase_BtnInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Purchase_BtnInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_purchase_btn(inputs)
	if (locale === "ar") return ar_purchase_btn(inputs)
	if (locale === "de") return de_purchase_btn(inputs)
	if (locale === "es") return es_purchase_btn(inputs)
	if (locale === "fr") return fr_purchase_btn(inputs)
	if (locale === "it") return it_purchase_btn(inputs)
	if (locale === "ja") return ja_purchase_btn(inputs)
	if (locale === "ko") return ko_purchase_btn(inputs)
	if (locale === "pt_br") return pt_br_purchase_btn(inputs)
	if (locale === "ru") return ru_purchase_btn(inputs)
	if (locale === "th") return th_purchase_btn(inputs)
	if (locale === "tr") return tr_purchase_btn(inputs)
	if (locale === "zh_cn") return zh_cn_purchase_btn(inputs)
	return zh_tw_purchase_btn(inputs)
});